import { ConversationRatedEntry } from 'lib-shared-legacy-types';

import type { Score } from 'fable/ScoreIcon';

import { SatisfactionMessage } from '../../../conversation/components/messages/SatisfactionMessage';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import styles from './logEntry/logEntry.module.scss';
import { UserLink } from './userLink/userLink';

type ConversationRatedProps = {
  entry: ConversationRatedEntry;
};

export const ConversationRated = ({
  entry,
}: ConversationRatedProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const agentName = getLogEntryAuthorName({
    ...entry,
    author: entry.agent,
  });

  const agentLink = entry.agent ? (
    <UserLink userId={entry.agent.id}>{agentName}</UserLink>
  ) : undefined;

  const text = (
    <>
      Conversation is rated by customer {authorLink}
      {agentLink && <> for agent {agentLink}</>}
    </>
  );

  return (
    <LogEntry entry={entry} text={text}>
      {entry.rating_score ? (
        <div className={styles.message}>
          <SatisfactionMessage
            ratingStyle="numbers"
            date=""
            score={entry.rating_score as Score}
            comment={entry.rating_message || ''}
          />
        </div>
      ) : null}
    </LogEntry>
  );
};
